import React from "react";
import { Form, Row, Col } from "antd";
 // import UniDropAdv from "../ReportFormGenerator/UniDrop/UniDropAdv";
import UnifiedInput from "../../components/ReportFormGenerator/UnifiedInput/UnifiedInput";
import StablePrime from "../../components/Tables/StablePrime";

function LineDashPlanning({ lid }) {
  const [form] = Form.useForm();

  const [st, setSt] = React.useState(null);

  const Changed = (value) => {
    
    setSt(form.getFieldsValue());
  };

  const Table = () => {
    // setSt(null);
    return (
      <>
        {st ? (
          <div style={{ marginTop: "0px" }}>
            <StablePrime
              url="/linedash/tabs/plan"
              data={{ ...st, lid: lid, limit: 10 }}
              identity="Plan"
            />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <div className="AuditSection CreateAudit" style={{ marginTop: "-5px" }}>
      <div className="ThemeForm">
        <Form
          name="ReportForm"
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          layout="horizontal"
          colon={false}
          size="large"
        >
          <Row justify="center">
            <Col span={12}>
              {/* <CropDown
                name="st"
                label="Status"
                url="/cropdown"
                urlData={{ name: "CIHOX", includeAll: true }}
                required={true}
                errorMessage="Please Select Status !"
                placeholder="Select Status"
                searchable={true}
                onChange={Changed}
              /> */}
              <UnifiedInput
                form={form}
                colSpan={24}
                multiSelect={false}
                typ="dropDown"
                url={"/cropdown"}
                disabled={false}
                source={"cropdown"}
                sourceParams={{ name: "CIHOX" }}
                pname={"status"}
                name={"st"}
                label="Status"
                errorMessage={"Please Select Status !"}
                required={true}
                placeholder="Select Status"
                defaultValue={""}
                searchable={true}
                includeAll={false}
                auxOnChange={Changed}
              />
              {/* <UniDropAdv
                form={form}
                colSpan={24}
                multiSelect={false}
                url={"/cropdown"}
                disabled={false}
                source={"cropdown"}
                urlData={{ name: "CIHOX" }}
                pname={"status"}
                name={"st"}
                label={"Status"}
                errorMessage={"Please Select Status !"}
                required={true}
                placeholder={"Select Status"}
                defaultValue={""}
                searchable={true}
                includeAll={true}
                onChange={Changed}
              /> */}
            </Col>
          </Row>
        </Form>
        <Table />
        {/* <div style={{ marginTop: "0px" }}>
          <StablePrime
            url="/linedash/tabs/plan"
            data={{ lid: lid, st: st ? st : {}, limit: 10 }}
            identity="Plan"
          />
        </div> */}
      </div>
    </div>
  );
}

export default React.memo(LineDashPlanning);
